<template>
  <div class="header" :class="{ header_show: headerShow, shadow: headerShowActive }">
    <div class="header_container">
      <div class="header_content">
        <div class="logo">
          <router-link to="/" class="logo-link">
            <div class="logo-container">
              <img src="../assets/img/index/ranyuanicon.png" alt="logo" class="logo-img" />
              <div class="logo-text">
                <span class="logo-title">燃源科技</span>
                <span class="logo-subtitle">RANYUAN TECH</span>
              </div>
            </div>
          </router-link>
        </div>
        
        <div class="menu-wrapper">
          <div class="menu-item" v-for="(nav, index) in navList" :key="index">
            <router-link :to="nav.path" class="menu-link" :class="{ active: $route.path === nav.path }">
              <span class="menu-text">{{ nav.title }}</span>
              <div class="menu-indicator"></div>
            </router-link>
          </div>
        </div>

        <div class="mobile-menu-toggle" @click="toggleMobileMenu">
          <div class="hamburger" :class="{ active: mobileMenuOpen }">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" :class="{ active: mobileMenuOpen }">
      <div class="mobile-menu-content">
        <div class="mobile-menu-item" v-for="(nav, index) in navList" :key="index">
          <router-link :to="nav.path" class="mobile-menu-link" @click="closeMobileMenu">
            {{ nav.title }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["navItem", "imgItem"],
  data() {
    return {
      navList: [
          {
              title: '首页',
              path: '/index'
          },
          {
              title: '产品与服务',
              path: '/product'
          },
          /* {
              title: '新闻中心',
              path: '/news'
          }, */
          {
              title: '人才招聘',
              path: '/job'
          },
          {
              title: '关于',
              path: '/about'
          }/* ,
          {
              title: '登录',
              path: '/login'
          } */
      ],
      headerShow: this.$store.state.headerShow,
      headerShowActive: this.$store.state.headerShadowActive,
      navDarkActive: this.$store.state.navDarkActive,
      headerLogoShow: this.$store.state.headerLogoShow,
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 80px;
  background: rgba(10, 25, 41, 0.8);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  z-index: 999;
  transition: all 0.3s ease;

  .header_container {
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .header_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }

  .logo {
    .logo-link {
      text-decoration: none;
      color: inherit;
    }

    .logo-container {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .logo-img {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      transition: transform 0.3s ease;
    }

    .logo-container:hover .logo-img {
      transform: scale(1.1) rotate(5deg);
    }

    .logo-text {
      display: flex;
      flex-direction: column;
    }

    .logo-title {
      font-size: 20px;
      font-weight: 700;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .logo-subtitle {
      font-size: 10px;
      color: rgba(255, 255, 255, 0.6);
      letter-spacing: 1px;
    }
  }

  .menu-wrapper {
    display: flex;
    gap: 32px;

    .menu-item {
      position: relative;
    }

    .menu-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-decoration: none;
      color: rgba(255, 255, 255, 0.8);
      font-weight: 500;
      padding: 8px 16px;
      border-radius: 8px;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
        transition: left 0.5s ease;
      }

      &:hover::before {
        left: 100%;
      }

      &:hover {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-2px);
      }

      &.active {
        color: #3370ff;
        background: rgba(51, 112, 255, 0.1);
      }
    }

    .menu-text {
      position: relative;
      z-index: 1;
    }

    .menu-indicator {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background: linear-gradient(90deg, #667eea, #764ba2);
      transition: width 0.3s ease;
    }

    .menu-link:hover .menu-indicator,
    .menu-link.active .menu-indicator {
      width: 100%;
    }
  }

  .mobile-menu-toggle {
    display: none;
    cursor: pointer;
    padding: 8px;

    .hamburger {
      width: 24px;
      height: 18px;
      position: relative;
      transition: all 0.3s ease;

      span {
        display: block;
        width: 100%;
        height: 2px;
        background: #ffffff;
        position: absolute;
        transition: all 0.3s ease;

        &:nth-child(1) {
          top: 0;
        }

        &:nth-child(2) {
          top: 8px;
        }

        &:nth-child(3) {
          top: 16px;
        }
      }

      &.active {
        span {
          &:nth-child(1) {
            transform: rotate(45deg);
            top: 8px;
          }

          &:nth-child(2) {
            opacity: 0;
          }

          &:nth-child(3) {
            transform: rotate(-45deg);
            top: 8px;
          }
        }
      }
    }
  }

  .mobile-menu {
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    height: 0;
    background: rgba(10, 25, 41, 0.95);
    backdrop-filter: blur(20px);
    overflow: hidden;
    transition: height 0.3s ease;

    &.active {
      height: calc(100vh - 80px);
    }

    .mobile-menu-content {
      padding: 32px 24px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .mobile-menu-item {
      .mobile-menu-link {
        display: block;
        padding: 16px;
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        font-size: 18px;
        font-weight: 500;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          color: #ffffff;
          background: rgba(255, 255, 255, 0.1);
          transform: translateX(8px);
        }
      }
    }
  }

  &.shadow {
    background: rgba(10, 25, 41, 0.95);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
}

@media (max-width: 768px) {
  .header {
    height: 60px;

    .header_container {
      padding: 0 16px;
    }

    .menu-wrapper {
      display: none;
    }

    .mobile-menu-toggle {
      display: block;
    }

    .logo {
      .logo-text {
        display: none;
      }

      .logo-img {
        width: 40px;
        height: 40px;
      }
    }

    .mobile-menu {
      top: 60px;

      &.active {
        height: calc(100vh - 60px);
      }
    }
  }
}
</style>
